<template>
    <div class="overflowTxt" @mouseenter="showFullText" @mouseleave="hideFullText">
        <el-tooltip v-if="isHovering" enterable effect="dark" :content="txt" placement="top-start">
            <div ref="showTxt" class="ellipsis flotTxt" @click="copyText(txt)">{{ txt ? txt : '' }}</div>
        </el-tooltip>
        <div ref="showTxt" class="ellipsis" v-else @click="copyText(txt)">{{ txt ? txt : '' }}</div>
    </div>
</template>

<script>
export default {
    props: {
        txt: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            isHovering: false,
            isOverflowing: false
        };
    },
    methods: {
        showFullText() {
            if (this.isOverflowing) {
                this.isHovering = true;
            }
        },
        hideFullText() {
            this.isHovering = false;
        },
        checkOverflow() {
            this.$nextTick(() => {
                const el = this.$refs.showTxt;
                if (el) {
                    this.isOverflowing = el.scrollWidth > el.offsetWidth;
                }
            });
        },
        copyText(text, tooltipStr) {
            let textarea = document.createElement('textarea'); //创建临时元素
            textarea.value = text; //设置要复制的内容
            document.body.appendChild(textarea); //将该元素添加到页面上
            textarea.select(); //选中输入框中的内容
            try {
                let successful = document.execCommand('copy'); //执行复制命令
                if (successful) {
                    this.$message.success(`${tooltipStr || ''}复制成功！`);
                } else {
                    console.log('无法复制！');
                }
            } catch (err) {
                console.error('无法复制！', err);
            } finally {
                document.body.removeChild(textarea); //移除临时元素
            }
        }
    },
    mounted() {
        this.checkOverflow();
    },
    watch: {
        txt() {
            this.checkOverflow();
        }
    }
};
</script>

<style lang="less" scoped>
.overflowTxt {
    width: 100%;
}
.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.flotTxt:hover {
    color: #409eff;
    cursor: pointer;
}
</style>